import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-content-wrapper',
  imports: [],
  templateUrl: './content-wrapper.html',
  styleUrl: './content-wrapper.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentWrapper {}
